import React from "react";

const LoadDataError = ({ message }) => {
  return <div className="loadData_error">{message}</div>;
};

export default LoadDataError;
